var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFinalizeSaleIcon = function SvgFinalizeSaleIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "second-button-icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 14",
    d: "M8.947 10.644a1.929 1.929 0 0 0 3.258 1.979l3.092-3.68a1.928 1.928 0 0 0-2.53-2.854l-4.07-3.393A1.929 1.929 0 0 0 5.452.687l-3.089 3.68a1.927 1.927 0 0 0 2.5 2.871l1.039.867L.575 13.41a1.974 1.974 0 1 0 3.012 2.53l4.336-6.152Zm-.85-7.112 3.942 3.29-2.5 2.98-3.942-3.29Zm6.3 3.48a.906.906 0 0 1 .113 1.273l-3.089 3.68a.902.902 0 1 1-1.382-1.16l3.089-3.68a.9.9 0 0 1 1.269-.114ZM3.26 6.297a.906.906 0 0 1-.111-1.271l3.089-3.68a.902.902 0 1 1 1.382 1.16l-3.089 3.68a.9.9 0 0 1-1.271.112m-.512 9.053a.948.948 0 1 1-1.451-1.213l5.4-5.373.436.364Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 15",
    d: "M19.482 18.975h-.955V17.27a1.626 1.626 0 0 0-1.624-1.624H8.815a1.626 1.626 0 0 0-1.624 1.624v1.705h-.955a.513.513 0 1 0 0 1.026h13.246a.513.513 0 1 0 0-1.026ZM8.217 17.27a.6.6 0 0 1 .6-.6h8.088a.6.6 0 0 1 .6.6v1.705H8.22Z"
  }))));
};
export default SvgFinalizeSaleIcon;